import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Conciliaciones',
      description: 'Conciliación de ingresos, nómina, egresos y creación de balanzas y pólizas contables.',
    },
    {
      icon: 'ri-calculator-line',
      title: 'Contabilidad General',
      description: 'Registro contable conforme a las NIF para cumplir eficientemente con obligaciones fiscales.',
    },
    {
      icon: 'ri-computer-line',
      title: 'Tecnología',
      description: 'Consultoría en implementación de sistemas de gestión para el desarrollo de proyectos.',
    },
  ];

  const testimonials = [
    {
      name: 'Lucía Lozano',
      company: 'Dinamo S.A.',
      text: 'Me ayudaron mucho con mis conciliaciones de Nómina, mi capital nunca estuvo en riesgo, muy buenos resultados. Gracias por su asesoría y servicio profesional.',
    },
    {
      name: 'Juan Carlos Herrera',
      company: 'Pigma Sensei',
      text: 'Pude encontrar respuestas de asuntos financieros y administrativos para impulsar mi empresa sin ningún contratiempo.',
    },
  ];

  const stats = [
    { value: '86,400', label: 'Horas de Consultoría' },
    { value: '5+', label: 'Años de Experiencia' },
    { value: '100%', label: 'Clientes Satisfechos' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />

      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://kronoscc.com/wp-content/uploads/2025/02/corporate_09.jpeg"
            alt="Consultoría contable profesional"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-heading font-bold text-5xl md:text-6xl lg:text-7xl text-white mb-6 leading-tight">
            Kronos CEO Consultores, S.C.
          </h1>
          <p className="font-body text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Consultoría sobresaliente en áreas contable, fiscal, administrativa y automatización de procesos
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/contacto"
              className="px-8 py-4 bg-gold hover:bg-gold/90 text-primary font-heading font-bold text-base rounded-lg transition-all duration-300 hover:scale-105 shadow-xl whitespace-nowrap"
            >
              Agenda tu Consulta Gratuita
            </Link>
            <a
              href="tel:+525614025070"
              className="px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-heading font-bold text-base rounded-lg transition-all duration-300 backdrop-blur-sm border-2 border-white/30 whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              56 1402 5070
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20">
            {stats.map((stat, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
                <div className="font-heading font-bold text-4xl md:text-5xl text-gold mb-2">{stat.value}</div>
                <div className="font-body text-base text-white/90">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-primary mb-4">¿Quiénes Somos?</h2>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
            <p className="font-body text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
              <strong>KRONOS CEO Consultores S.C.</strong> es una sociedad mexicana conformada por un grupo de profesionales enfocados a brindar sus conocimientos de manera ética y profesional para dar soluciones y proporcionar servicio de calidad a cada uno de nuestros clientes, brindando consultoría personalizada en tiempo y forma para cumplir con sus obligaciones fiscales.
            </p>
            <p className="font-body text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed mt-6">
              Somos una empresa especializada en resolver y prevenir riesgos financieros, contables, administrativos y fiscales, mediante herramientas tecnológicas.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-primary mb-4">Nuestros Servicios</h2>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
            <p className="font-body text-lg text-gray-700 max-w-3xl mx-auto">
              Ofrecemos soluciones integrales para tu negocio
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:-translate-y-2 group"
              >
                <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors">
                  <i className={`${service.icon} text-3xl text-primary group-hover:text-gold transition-colors`}></i>
                </div>
                <h3 className="font-heading font-bold text-xl text-primary mb-4">{service.title}</h3>
                <p className="font-body text-sm text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/servicios"
              className="inline-block px-8 py-4 bg-primary hover:bg-primary-dark text-white font-heading font-bold text-base rounded-lg transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap"
            >
              Ver Todos los Servicios
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-primary mb-4">Testimonios</h2>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
            <p className="font-body text-lg text-gray-700">Lo que dicen nuestros clientes</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg">
                <div className="flex items-start mb-6">
                  <img
                    src="https://kronoscc.com/wp-content/uploads/2025/02/Rectangle_30.png"
                    alt="Quote"
                    className="w-12 h-10"
                  />
                </div>
                <p className="font-body text-base text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center">
                  <div>
                    <h4 className="font-heading font-bold text-base text-primary">{testimonial.name}</h4>
                    <p className="font-body text-sm text-gray-600">{testimonial.company}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-white mb-6">¿Tiene alguna duda?</h2>
          <p className="font-body text-lg text-white/90 mb-8 max-w-2xl mx-auto">
            Agenda una consulta gratuita y descubre cómo podemos ayudarte
          </p>
          <Link
            to="/contacto"
            className="inline-block px-8 py-4 bg-gold hover:bg-gold/90 text-primary font-heading font-bold text-base rounded-lg transition-all duration-300 hover:scale-105 shadow-xl whitespace-nowrap"
          >
            Agendar Consulta
          </Link>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-primary mb-4">Nuestra Ubicación</h2>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
            <p className="font-body text-lg text-gray-700">Visítanos en nuestra oficina</p>
          </div>

          <div className="rounded-xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.8!2d-99.2489!3d19.3738!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDIyJzI1LjciTiA5OcKwMTQnNTYuMCJX!5e0!3m2!1ses!2smx!4v1234567890"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de Kronos Consultoría Contable"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;